export type PostcodesGroupedByCity = Record<string, string[]>
export type Location = { city: string; postcode: string }

export const groupPostcodesByCity = (
  locations: Location[],
): PostcodesGroupedByCity => {
  const emptyGrouping: PostcodesGroupedByCity = {}
  const postcodesGroupedByCity = locations.reduce(
    (previousPostcodesGroupedByCity, { city, postcode }) => {
      const existingPostcodesForCity =
        previousPostcodesGroupedByCity[city] ?? []
      return {
        ...previousPostcodesGroupedByCity,
        [city]: postcode
          ? [...existingPostcodesForCity, postcode]
          : existingPostcodesForCity,
      }
    },
    emptyGrouping,
  )

  return postcodesGroupedByCity
}
